export const WIDGET_KEYS = {
  OCCURRENCE_ID: 'occurrence_id',
  PACKAGE_ID: 'package_id',
  PACKAGES_COUNT: 'packages_count',
  PICKUP_DATE: 'pickup_date',
  DEAL_ID: 'deal_id',
  TOUR_ID: 'tour_id',
  AVAILABILITY_ID: 'availability_id',
};

export const STATE_TYPES = {
  RIDERS: 'riders',
  VEHICLES: 'vehicles',
  EXTRAS: 'extras',
  CHECKOUT: 'checkout',
};

export const WIDGET_TYPE_IDENTIFIER = {
  GUIDED_RECURRING: 'guided_recurring',
  GUIDED_NON_RECURRING: 'guided_non_recurring',
  SELF_GUIDED: 'self_guided',
  SELF_DRIVE: 'self_drive',
};